import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "select" ]

  connect(){
    this.selectTargets.forEach( (selectTarget) => {

      if(!$(selectTarget).prop('disabled') && !$(selectTarget).closest('fieldset').prop('disabled')){
        $(selectTarget).select2({
          width: '100%',
          theme: 'bootstrap',
        })
      }
    })
  }

  disconnect(){
    this.selectTargets.forEach( (selectTarget) => {
      if($(selectTarget).hasClass('.select2-hidden-accessible')){
        $(selectTarget).select2('destroy');
      }
    })
  }


}
